import { render, staticRenderFns } from "./HistoryCustomer.vue?vue&type=template&id=e1f76158&scoped=true"
import script from "./HistoryCustomer.vue?vue&type=script&lang=js"
export * from "./HistoryCustomer.vue?vue&type=script&lang=js"
import style0 from "./HistoryCustomer.vue?vue&type=style&index=0&id=e1f76158&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f76158",
  null
  
)

export default component.exports